module.exports = __webpack_public_path__ + "img/18a570902d3c4ebcc4f81123d565da43.png";